// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a34a2f2c","61":"833eb0d9","322":"2f46b90f","331":"02a86e57","404":"8da64887","526":"2d1ca3b4","527":"80722180","603":"e43d7045","604":"10b59ab1","985":"a9620443","995":"97469dcc"}[chunkId] + ".chunk.js";
};